<template>
  <router-view v-if="!auth"/>
  <Toolbar v-else>
    <router-view/>
  </Toolbar>
</template>

<script>
import { computed } from 'vue'
import { useStore } from 'vuex'
import { onMounted } from 'vue'
import { loginCustom } from './composables/loginComposable'

import Toolbar from "@/components/toolbar/toolbarComponent.vue"

export default {
  name: 'LayoutDefault',

  components: {
    Toolbar
  }
   ,
  setup () {
    const store = useStore() 
    const auth = computed(()=>store.getters.getAuth)
    const {login} = loginCustom()
     onMounted(async () => {
            if (localStorage.lDM && localStorage.date === new Date().toLocaleDateString('pt-br')) {
                await login({ id: localStorage.lDM, autoLogin: true });
            }
        });
    return {
      auth
    }
  }
}
</script>
